@if (packagesForm) {
  <div class="packages-container" [formGroup]="packagesForm">
    <div class="header">
      <div class="title">Packages</div>
      <div class="add" (click)="navigateToAddPackage()">Add package</div>
    </div>
    <div class="sub-header">
      Set up the package sizes you use for shipping.<br />
      New orders are matched to the first package that fits, so arrange them in order of priority.
    </div>
    @if (isPdqIqEnabled) {
      <div class="cards-wrapper pdq-iq-cards-wrapper">
        <div class="card-wrapper">
          <div class="pdq-iq-package-card">
            <div class="card">
              <div class="left-elements">
                <div class="left-title">
                  <div class="pdq-iq-title">
                    <pdq-icon icon="pdqiq" class="pdq-iq-icon"></pdq-icon><span>PDQ IQ Package Pairing</span>
                  </div>
                </div>
                <div class="left-details">
                  PDQ IQ Package Pairing calculates and selects the best package for your order in the event that no
                  other package rule is met. To enable this feature, please map Shopify metafields in Settings
                </div>
              </div>
            </div>
            <div class="right-elements" (mousedown)="$event.stopPropagation()">
              <pdq-slide-toggle
                formControlName="isPaccurateEnabled"
                [disabled]="!isPdqIqSettingsConfigured"
                (onToggle)="activatePdqIq()">
              </pdq-slide-toggle>
              @if (!isCarrier) {
                <pdq-dropdown
                  mode="default"
                  [disabled]="false"
                  [options]="pdqIqSettingsOptions"
                  [cta]="true"
                  [useOverlay]="true"
                  staticListMaxHeight="120"
                  [overlayPositions]="[
                    {
                      originX: 'start',
                      originY: 'top',
                      overlayX: 'end',
                      overlayY: 'top',
                    },
                    {
                      originX: 'start',
                      originY: 'bottom',
                      overlayX: 'end',
                      overlayY: 'bottom',
                    },
                  ]"
                  mode="ghost"
                  (onChange)="onPdqIqSettingsChange($event)"
                  icon="dots_menu"
                  [showArrow]="false">
                </pdq-dropdown>
              }
            </div>
          </div>
        </div>
      </div>
    }
    <div
      class="cards-wrapper package-cards-wrapper"
      [cdkDropListData]="pagedPackages"
      [cdkDropListDisabled]="!!searchTerm"
      cdkDropList
      (cdkDropListDropped)="drop($event)">
      <div class="card saved-packages-card">
        <div class="title">Saved packages</div>
        <pdq-input [withIcon]="true" icon="search" placeholder="Search packages" [control]="searchControl"></pdq-input>
      </div>
      @if (searchTerm && !filteredPackages.length) {
        <div class="card empty-search">No packages match your search</div>
      }
      @for (package of pagedPackages; track package.id) {
        <div class="card-wrapper" [cdkDragData]="package" cdkDrag>
          <app-settings-package-details [package]="package">
            <div class="right-elements" (mousedown)="$event.stopPropagation()">
              @if (!isCarrier) {
                <pdq-slide-toggle [formControlName]="package.id" (onToggle)="packageActiveChanged(package)">
                </pdq-slide-toggle>
              }
              @if (!isCarrier) {
                <pdq-dropdown
                  mode="default"
                  [disabled]="false"
                  [options]="options"
                  [useOverlay]="true"
                  staticListMaxHeight="120"
                  [overlayPositions]="[
                    {
                      originX: 'start',
                      originY: 'top',
                      overlayX: 'end',
                      overlayY: 'top',
                    },
                    {
                      originX: 'start',
                      originY: 'bottom',
                      overlayX: 'end',
                      overlayY: 'bottom',
                    },
                  ]"
                  [cta]="true"
                  mode="ghost"
                  (onChange)="onChange($event, package)"
                  icon="dots_menu"
                  [showArrow]="false">
                </pdq-dropdown>
              }
            </div>
            @if (package.rules?.conditionsSubsets?.length) {
              <div class="conditions-wrapper" (mousedown)="$event.stopPropagation()">
                <div class="condition-wrapper" (click)="package.isDisplayCondition = !package.isDisplayCondition">
                  <div class="condition-text">
                    {{ package.isDisplayCondition ? 'Hide rules' : 'Show rules' }}
                  </div>
                  <img class="arrow" [ngClass]="{ down: !package.isDisplayCondition }" src="./assets/icons/arrow.svg" />
                </div>
                @if (package.isDisplayCondition) {
                  <div class="packages-condition">
                    <div class="conditions-sub-header">If order:</div>
                    <!-- <div class="conditions-header">
                    Order must match <b>{{ package.rules.operator }}</b> of the following conditions:
                  </div> -->
                    @for (rules of package.rules.conditionsSubsets; track rules; let conditionsIndex = $index) {
                      <div class="conditions">
                        <div class="tag-wrapper">
                          @if (conditionsIndex > 0) {
                            <pdq-tag value="Or" size="medium" variant="default" mode="rounded" padding="true"></pdq-tag>
                          }
                        </div>
                        @for (rule of rules.rulesArray; track rule) {
                          <div class="condition">
                            <span class="light-condition">{{ rule.displayEntity }}</span>
                            {{ rule.displayCondition }}
                            @for (val of rule.value; track val; let valIndex = $index) {
                              <span class="light-condition">
                                @if (
                                  val &&
                                  (rule.filterEntity === rulesFilterEntity.SKU ||
                                    rule.filterEntity === rulesFilterEntity.PRODUCT_TYPE) &&
                                  valIndex === 1
                                ) {
                                  <span>quantity is</span>
                                }
                                {{ val?.label ? val.label : val }}
                              </span>
                            }
                          </div>
                        }
                      </div>
                    }
                  </div>
                }
              </div>
            }
          </app-settings-package-details>
        </div>
      }
    </div>
    @if (hasPreviousPage || hasNextPage) {
      <div class="packages-pagination">
        <pdq-pagination
          mode="simple"
          [rangeLabel]="rangeLabel"
          [hasPreviousPage]="hasPreviousPage"
          [hasNextPage]="hasNextPage"
          (onCursorPageChange)="onCursorPageChange($event)">
        </pdq-pagination>
      </div>
    }
  </div>
}
<pdq-snackbar
  [variant]="notification.type"
  [mode]="notification.mode"
  [notificationText]="notification.msg"
  [notificationState]="notification.state">
</pdq-snackbar>
